<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 1;}

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;}
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

  
  }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.9 210.3" height="100%" width="100%">
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="sideplank">
       
        
        <path
          fill="var(--shirt)"
          d="m1884 1226 9-15a111 111 0 0 1 10-13 22 22 0 0 1 6-5 42 42 0 0 1 16-4 114 114 0 0 1 22 0 79 79 0 0 1 20 4l6 3-1 1c-3 1-6 5-5 7s0 5-1 7a29 29 0 0 0-1 10l1 1 9 2a86 86 0 0 1 13 3l6 1a48 48 0 0 0 11 2l9 1a25 25 0 0 1 6 1l11 2 11 2c1 0 2 0 3 2a162 162 0 0 1-11 33 29 29 0 0 0-2 8l-1 19-2 24-3 11a12 12 0 0 0-1 5c0 2-1 2-3 2-9-1-18-1-26-4a133 133 0 0 0-23-7 48 48 0 0 0-7-1c-14 0-27-4-40-8a419 419 0 0 1-15-3l-4 15c-1 3-2 4-4 4l-14-5a4 4 0 0 0-3 0 10 10 0 0 1-6 0l-5-2c-4-4-2-9-1-13 1-1 0-2-1-3a4 4 0 0 1-1-5c4-8 2-16 2-24v-19l-1-3h1c3 1 5 2 5 6l2 1 3-2 4-2a18 18 0 0 0 7-12 24 24 0 0 0 0-13 41 41 0 0 0-9-14h-2Z"
          transform="translate(-1799 -1188)"
        />
        <path
          d="m2026 1334 3-12 2-23 1-19a29 29 0 0 1 2-8 162 162 0 0 0 11-34l1-1c8 3 16 4 23 8 7 6 16 8 23 14 2 2 4 2 5 1s1-3-1-5a23 23 0 0 0-2-2 25 25 0 0 0-6-5c-1 0-2 0-1-1h1l10 5 11 4 17 8c2 1 3 3 3 5 1 3 0 5-1 8v14c0 5-2 9-4 14v1a5 5 0 0 1-2 1l-12-2-3 1c-1 1 0 3 1 4 5 4 6 10 6 16a43 43 0 0 1-1 13l-3 6a4 4 0 0 1-3 1c-9 1-17 1-26-1l-32-6a24 24 0 0 1-8-3 6 6 0 0 0-4-1 19 19 0 0 1-11-1Z"
          transform="translate(-1799 -1188)"
          fill="var(--pants)"
        />
        <path
          fill="var(--flesh)"
          d="M2113 1338a43 43 0 0 0 1-12c0-6-1-12-6-16-1-1-2-2-1-4s2-1 3-1l12 2a5 5 0 0 0 2-1l4 2c10 2 19 5 28 10 5 2 10 4 15 3a44 44 0 0 1 9 1l16 2 22 8c11 4 23 7 34 7a39 39 0 0 1 6 0h5c2 2 2 2 0 3-1 1-3 1-2 2l1 10a14 14 0 0 1-9 0l-14-1-24-1-31-2c-8 0-15-3-23-5a97 97 0 0 0-22-5l-13-2a50 50 0 0 0-11 0h-2ZM1884 1226l2 1a41 41 0 0 1 9 13 24 24 0 0 1 1 13 18 18 0 0 1-8 12l-4 3-3 1-2-1c0-3-2-5-5-6l-1 1-8-3h-2l-9 2c-5 1-10 3-15 2a3 3 0 0 1-2-2c-1-1 1-1 1-2h3l-13-4a9 9 0 0 1-6-4 7 7 0 0 0-5-3c-4 0-6-3-5-6a53 53 0 0 0 6-22c0-6 4-8 9-6a4 4 0 0 0 4 0c4-2 7-2 11-1l9 3c0-2-2-2-2-2a8 8 0 0 0-1-1 2 2 0 0 1 0-3 2 2 0 0 1 3 0c4 1 9 3 11 7l7 7a13 13 0 0 0 7 4c4 1 6 1 8-2v-1ZM1876 1329l4 2a10 10 0 0 0 6 0 4 4 0 0 1 3 0l14 5a14 14 0 0 1-1 3 23 23 0 0 0-2 10l-2 10a41 41 0 0 0-3 10 2 2 0 0 0 2 3c4 3 6 7 8 12a2 2 0 0 1-1 3 2 2 0 0 1-4-1l-2-4-1-1a1 1 0 0 0 0 1c0 2 0 5 3 6a8 8 0 0 1 3 3v4a3 3 0 0 1-3 1l-3-2c1 2 0 3-1 4s-3 0-4-1a3 3 0 0 0-2 0c-3 1-6 1-8-1a3 3 0 0 0-2-1c-5 0-8-2-10-6v-4l2-8-1-6-1-7c-2-6 0-12 2-17l3-12 1-6Z"
          transform="translate(-1799 -1188)"
        />
        <path
          fill="var(--hair)"
          d="M1818 1221c0-6 4-8 9-6a4 4 0 0 0 4 0c4-2 7-2 11-1l9 3c0-2-2-2-2-2l-10-4-6-4a27 27 0 0 1-7-2c-5-1-7-1-10 3l-1 2-1 1c-4 0-7 3-9 6a34 34 0 0 0-5 18l-1 6v5c1 4 4 5 8 6l11 4a80 80 0 0 0 17 4h6l-13-4a9 9 0 0 1-6-4 7 7 0 0 0-5-3c-4 0-6-3-5-7a53 53 0 0 0 6-21Z"
          transform="translate(-1799 -1188)"
        />
        <path
          fill="var(--flesh)"
          d="M2124 1305c2-5 4-9 4-15v-13c0-3 2-5 1-8l3 2 14 8c5 3 9 5 14 6 9 3 18 3 27 5a158 158 0 0 1 15 6l36 16a138 138 0 0 0 15 5 34 34 0 0 0 6 1 19 19 0 0 1 10 4 3 3 0 0 0 3 0l-2 1a16 16 0 0 1-3 0c-3 0-3 0-4 2a47 47 0 0 0 0 6l1 4c1 2 0 1-1 2-5-1-9-3-13-6a13 13 0 0 0-4-1l-36-6c-10-1-20-3-29-7l-14-5-13-2c-9-1-17-2-25-5a23 23 0 0 0-5 0ZM2109 1256l-11-4-10-5h-2l1 1a25 25 0 0 1 7 5 23 23 0 0 1 2 2c2 2 2 3 1 5s-3 1-5-1c-7-6-16-8-23-14-7-5-15-5-23-8l-1 1-3-2-11-2-12-2a25 25 0 0 0-5-1l-9-1a48 48 0 0 1-11-2l-7-1a86 86 0 0 0-12-3l-9-2-1-1a29 29 0 0 1 1-10c1-2 2-4 1-7-1-2 2-6 5-7l1-1 18 6c9 3 19 4 28 8l36 16c6 3 13 7 20 8l12 2a5 5 0 0 1 2 1c7 4 12 8 16 15l4 4Z"
          transform="translate(-1799 -1188)"
        />
        <path
          d="M2310 1333c-1-5-3-9-8-11l-12-1h-11a8 8 0 0 0-3 0 13 13 0 0 0-4 1l-2 2a16 16 0 0 1-3-1c-3 0-3 0-4 3a47 47 0 0 0 0 5l1 4c1 1 0 1-1 2h1c1 2-1 1-1 2 2 2 2 2 0 3l-2 2 1 10a163 163 0 0 0 19 4 108 108 0 0 0 15 4c4 0 5-1 6-4a37 37 0 0 0 1-10c0-2 1-2 2-2a7 7 0 0 0 5-6l1-1v-4l-1-2Z"
          transform="translate(-1799 -1188)"
          fill="var(--hair)"
        />
        <path
          fill="var(--shirt)"
          d="M1884 1226v1-1Z"
          transform="translate(-1799 -1188)"
        />
        <path
          fill="var(--hair)"
          d="M1818 1221c0-6 4-8 9-6a4 4 0 0 0 4 0c4-2 7-2 11 0l9 2-2-2-10-4-6-4a28 28 0 0 1-7-1c-5-2-7-2-10 3l-1 2h-1c-4 0-7 3-9 6a34 34 0 0 0-5 18l-1 6v6c1 3 4 4 8 5l11 4a79 79 0 0 0 17 4h6l-13-4a9 9 0 0 1-6-3 7 7 0 0 0-5-4c-4 0-6-3-5-6a53 53 0 0 0 6-22Z"
          transform="translate(-1799 -1188)"
        />
      </g>
    </g>
    </g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>